export default __webpack_public_path__ + "static/trs-e938efa936bd8ce90e3c3a85b71224fd.png";